
import traineeService from "@/services/trainee.service"

export default {
    name: "Setting",
    model: {
        prop: "value",
        event: "change",
    },
    props: {
        identifier: {
            type: String,
            required: true,
        },
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
        }
    },
    emits: ["change"],
    methods: {
        onToggle(value) {
            if (this.isLoading) return
            this.isLoading = true
            this.$emit("change", value)
            const trainee = this.$auth.user.trainee
            traineeService
                .update(trainee.id, {
                    ...trainee,
                    [this.identifier]: value,
                })
                .then(() => {
                    this.$auth.fetchUser()
                })
                .catch((err) => {
                    console.warn(err)
                    this.$emit("change", !value)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
